import { noop } from './noop.js';

function isObject(value) {
  return typeof value === "object" && value !== null && "hasOwnProperty" in value;
}
function isDefined(value) {
  return value !== void 0 && value !== null;
}
function isString(value) {
  return typeof value === "string";
}
function isFunction(value) {
  return typeof value === "function" && value instanceof Function;
}
function isError(value) {
  return value instanceof Error;
}
function isNumber(value) {
  return typeof value === "number" && !isNaN(value);
}
const isTruthy = (x) => !!x;
function isRequired(obj) {
  return Object.values(obj).every((value) => value !== void 0 && value !== null);
}
const isNoop = (fn) => fn === noop;
const isNullOrUndefined = (value) => value === null || value === void 0;
const isUndefined = (value) => value === void 0;
const isEmptyArray = (value) => Array.isArray(value) && value.length === 0;
const ensureError = (value) => {
  if (value instanceof Error) return value;
  let errorMessage;
  if (typeof value === "string") {
    errorMessage = value;
  } else {
    try {
      errorMessage = `Non-error value thrown: ${JSON.stringify(value)}`;
    } catch {
      errorMessage = `Non-error value thrown: [Value cannot be stringified]`;
    }
  }
  const error = new Error(errorMessage, {
    cause: value
  });
  return error;
};

export { ensureError, isDefined, isEmptyArray, isError, isFunction, isNoop, isNullOrUndefined, isNumber, isObject, isRequired, isString, isTruthy, isUndefined };
//# sourceMappingURL=index.js.map
